/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowBoldLeft: {
  name: 'arrow-bold-left';
  data: string;
} = {
  name: 'arrow-bold-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.447 5.106A1 1 0 0 1 12 6v2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-8v2a1 1 0 0 1-1.6.8l-8-6a1 1 0 0 1 0-1.6l8-6a1 1 0 0 1 1.047-.094ZM4.667 12 10 16v-1a1 1 0 0 1 1-1h9v-4h-9a1 1 0 0 1-1-1V8l-5.333 4Z" fill="currentColor"/></svg>`,
};
